define([
	"dojo/_base/declare",
	"csi/comm/PostRequest",
	"csi/gallery/Widget",
	"csi/locale"
], function(declare,PostRequest,Gallery,locale) {
	
	return declare(Gallery, {
		prefClass: null,

		onDrawActionJobServiceStartStop: function(/*Context*/ctx, /*Action*/action, /*DOMNode*/refNode) {
			action.m_name = locale.resource(ctx.getNode().Status == "Running" ? "JobServiceStop" : "JobServiceStart");
			return action.toHtmlControl(ctx, refNode);
		},

		onActionJobServiceStartStop: function(ac) {
			new PostRequest("JobService", ac.getNode().Status == "Running" ? "Stop" : "Start")
				.post({sync:true});
		}
	});
});